import { render } from "./PricingComponent.vue?vue&type=template&id=19f14b76&scoped=true"
import script from "./PricingComponent.vue?vue&type=script&lang=js"
export * from "./PricingComponent.vue?vue&type=script&lang=js"

import "./PricingComponent.vue?vue&type=style&index=0&id=19f14b76&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19f14b76"]])

export default __exports__